import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { LEAD_CHANNEL_OPTIONS, getLeadChannelLabel, isLeadChannelSelectable } from '../leadsConfig';
import {
  LEADS_FORM_LABEL_GAP,
  LEADS_TEXT_SECONDARY,
  getLeadStageFilterChipSx,
  leadsGridChipSx,
  leadsSectionTitleSx,
} from './leadsUi.styles';

// Ancho mínimo de la fila para mostrar los 6 canales en una sola línea
// («Presencial» entra con 6px de padding). Más angosto: 3 + 3.
const CHANNEL_ROW_MIN_PX = 464;

/** El ancho que manda es el de la fila (diálogo o ficha), no el de la ventana. */
const leadChannelGridContainerSx = { containerType: 'inline-size' };

const leadChannelGridSx = {
  display: 'grid',
  gap: 0.75,
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  [`@container (min-width: ${CHANNEL_ROW_MIN_PX}px)`]: {
    gridTemplateColumns: `repeat(${LEAD_CHANNEL_OPTIONS.length}, minmax(0, 1fr))`,
  },
};

/** Mismo chip de etapa, estirado a su celda. */
const leadChannelGridChipSx = { ...leadsGridChipSx, px: '6px' };

/**
 * Canal del lead (opcional), con los mismos botones-chip que la etapa del
 * alta, repartidos en todo el ancho (6 columnas iguales; 3 + 3 si la fila es
 * angosta). Tocar el elegido lo limpia (`''`). Un canal no elegible a mano
 * (`share_form`: vino de una consulta) se muestra fijo, sin botones.
 *
 * @param {{ value: string, onChange: (channel: string) => void, disabled?: boolean }} props
 */
export default function LeadChannelPicker({ value = '', onChange, disabled = false }) {
  const current = value || '';
  if (current && !isLeadChannelSelectable(current)) {
    return (
      <Box>
        <Typography sx={{ ...leadsSectionTitleSx, mb: LEADS_FORM_LABEL_GAP }}>Canal</Typography>
        <Typography data-testid="lead-channel-readonly" sx={{ fontSize: '13px', color: LEADS_TEXT_SECONDARY }}>
          Desde link compartido
        </Typography>
      </Box>
    );
  }
  return (
    <Box sx={leadChannelGridContainerSx}>
      <Typography id="lead-channel-label" sx={{ ...leadsSectionTitleSx, mb: LEADS_FORM_LABEL_GAP }}>Canal (opcional)</Typography>
      <Box role="group" aria-labelledby="lead-channel-label" data-testid="lead-channel-options" sx={leadChannelGridSx}>
        {LEAD_CHANNEL_OPTIONS.map((channel) => (
          <Button
            key={channel}
            size="small"
            disabled={disabled}
            aria-pressed={current === channel}
            onClick={() => onChange(current === channel ? '' : channel)}
            sx={{ ...getLeadStageFilterChipSx(current === channel), ...leadChannelGridChipSx }}
          >
            {getLeadChannelLabel(channel)}
          </Button>
        ))}
      </Box>
    </Box>
  );
}
